import { IncidentRecord, Stack, useI18n } from '@daghfal/core';
import { Link, useParams } from 'react-router-dom';

/** One incident in full, closed and printed from here (FR-CHD-13, FR-CHD-14). */
export function IncidentPage() {
  const { t } = useI18n();
  const { id } = useParams();

  return (
    <Stack>
      <Link className="dg-button dg-button--ghost" to="/reports?tab=incidents">{t('action.back')}</Link>
      <IncidentRecord incidentId={Number(id)} as="staff" />
    </Stack>
  );
}
